/* eslint-disable @typescript-eslint/naming-convention */
export enum ETagsMutationType {
	SET_TAGS = 'setTags',
}
